export default {
  ADD_POSITION: "ADD_POSITION",
  EMPTY_POSITION: "EMPTY_POSITION",
  SET_POSITION_FOR_EDIT: "SET_POSITION_FOR_EDIT",
  SET_DATE: "SET_DATE",
  SET_TYPE_ACTION: "SET_TYPE_ACTION",
  POSITION_ADDED_IN_EDIT_ACTION: "POSITION_ADDED_IN_EDIT_ACTION",
  RESET_POSITION_IN_EDIT_ACTION: "RESET_POSITION_IN_EDIT_ACTION",
  RESET_DATE: "RESET_DATE",
};
